import { render, staticRenderFns } from "./RmaScanItem.vue?vue&type=template&id=3e4a67a7&"
import script from "./RmaScanItem.vue?vue&type=script&lang=js&"
export * from "./RmaScanItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports